import {baseEvent} from './baseEvent';
import {EVENTS} from '../events';

/**
 * @returns {import('./baseEvent').AmplitudeEvent}
 */
export function userEnteredScanner() {
	return baseEvent(EVENTS.USER_ENTERED_SCANNER, {});
}
